import React from 'react';
import {
  InputLabelProps,
  InputProps,
  SxProps,
  TextField,
  useTheme,
} from '@mui/material';

interface TextInputProps {
  required?: boolean;
  autoFocus?: boolean;
  fullWidth?: boolean;
  name: string;
  autoComplete?: string;
  type: string;
  value: string;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: InputProps;
  inputLabelProps?: InputLabelProps;
  sx?: SxProps;
  defaultValue?: string;
  error?: boolean;
  disabled?: boolean;
  multiline?: boolean;
  maxRows?: number;
  rows?: number;
  size?: 'small' | 'medium' | undefined;
  min?: number;
  max?: number;
  variant?: 'outlined' | 'filled' | 'standard';
  testId?: string;
}
export function TextInput({
  required,
  fullWidth,
  autoFocus,
  name,
  value,
  label,
  type,
  onChange,
  inputProps,
  inputLabelProps,
  autoComplete,
  sx,
  defaultValue,
  error,
  disabled,
  multiline,
  maxRows,
  rows,
  size = 'medium',
  min,
  max,
  variant,
  testId,
}: TextInputProps) {
  const theme = useTheme();
  return (
    <TextField
      data-testid={testId}
      variant={variant}
      size={size}
      type={type}
      margin="normal"
      color="primary"
      required={required}
      fullWidth={fullWidth}
      id={name}
      label={label}
      name={name}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      value={value}
      onChange={onChange}
      InputProps={inputProps}
      InputLabelProps={{
        style: { color: theme.palette.text.primary },
        ...inputLabelProps,
      }}
      sx={{
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
          {
            display: 'none',
          },
        '& input[type=number]': {
          MozAppearance: 'textfield',
        },
        ...sx,
      }}
      defaultValue={defaultValue}
      error={error}
      disabled={disabled}
      multiline={multiline}
      maxRows={maxRows}
      rows={rows}
    />
  );
}
